
import http from '../../config/axios';

const Auth = async() => { 
    const res = await http.get('/auth')  
    return res;   
}

export default Auth;